import React from "react";

// Onde sonore animée — ludique mais simple (barres qui dansent pendant l'enregistrement).
export function SoundWave({ active = true, bars = 7, className = "" }) {
  return (
    <span className={`sw-wrap ${active ? "" : "sw-static"} ${className}`} aria-hidden="true">
      <style>{`
        @keyframes sw-bounce { 0%,100%{transform:scaleY(0.28)} 50%{transform:scaleY(1)} }
        .sw-wrap{display:inline-flex;align-items:center;gap:2.5px;height:18px}
        .sw-bar{width:2.5px;height:100%;border-radius:3px;background:currentColor;transform-origin:center;animation:sw-bounce 0.9s ease-in-out infinite}
        .sw-static .sw-bar{animation:none;transform:scaleY(0.4);opacity:0.6}
      `}</style>
      {Array.from({ length: bars }).map((_, i) => (
        <span key={i} className="sw-bar" style={{ animationDelay: `${(i % 4) * 0.11}s` }} />
      ))}
    </span>
  );
}
